export default class TicketAgendamentoStatusEnum {
    static Agendado = 1
    static Realizado = 1
    static Cancelado = 1
}
